const WorkIcon = ({ fill }: { fill: string }) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.9996 5.33301C13.9509 5.3331 15.8585 5.93571 17.4801 7.06348C19.1017 8.19132 20.365 9.79445 21.109 11.6689C21.1851 11.8825 21.1851 12.1175 21.109 12.3311C20.365 14.2055 19.1017 15.8087 17.4801 16.9365C15.8585 18.0643 13.9509 18.6669 11.9996 18.667C10.0482 18.667 8.13989 18.0644 6.51815 16.9365C4.89656 15.8087 3.6342 14.2055 2.89022 12.3311C2.81394 12.1173 2.81394 11.8827 2.89022 11.6689C3.6342 9.79447 4.89656 8.19132 6.51815 7.06348C8.13989 5.93562 10.0482 5.33301 11.9996 5.33301ZM12.0006 9C10.3438 9.00011 9.00058 10.3432 9.00058 12C9.00069 13.6567 10.3439 14.9999 12.0006 15C13.6574 15 15.0005 13.6568 15.0006 12C15.0006 10.3431 13.6574 9 12.0006 9Z"
			fill={fill || "#D3D4D9"}
		/>
	</svg>
);

export default WorkIcon;
